import type { SubdomainInfo } from '@/types/subdomain';
import { KNOWN_DOMAINS } from '@/constants/domains';

/**
 * サブドメインの期待されるパーツ数
 * パターン: {airport}-{flight_type}-{terminal}-{floor}-{lounge}-{device_floor}
 */
const EXPECTED_SUBDOMAIN_PARTS = 6;

/**
 * サブドメインをパースして各コンポーネントを抽出する
 *
 * @param hostname - window.location.hostname
 * @returns サブドメイン情報、またはサブドメインがない場合はnull
 */
export const parseSubdomain = (hostname: string): SubdomainInfo | null => {
  // サブドメイン部分を取得
  const parts = hostname.split('.');

  // hostname全体が既知のドメインと完全一致する場合はサブドメインなし
  if (KNOWN_DOMAINS.includes(hostname)) {
    return null;
  }

  // サブドメインなしの場合（localhost のみなど）
  if (parts.length === 1) {
    return null;
  }

  // ベースドメインを取得（サブドメイン以降の部分）
  const baseDomain = parts.slice(1).join('.');

  // 既知のドメインかチェック
  const isKnownDomain = KNOWN_DOMAINS.some(
    (knownDomain) => baseDomain === knownDomain,
  );

  if (!isKnownDomain) {
    console.warn(`Unknown domain detected: ${baseDomain}`);
    return null; // 未知のドメインの場合はnullを返す
  }

  // サブドメイン部分を取得(最初の部分)
  const subdomain = parts[0];

  // ハイフンで分割
  // 期待されるパターン: {airport}-{flight_type}-{terminal}-{floor}-{lounge}-{device_floor}
  const components = subdomain.split('-');

  // サブドメインのパーツ数をバリデーション（指定パート数の場合のみ共有端末として認識）
  if (components.length !== EXPECTED_SUBDOMAIN_PARTS) {
    return null;
  }

  const [airport, flightType, terminal, floor, lounge, deviceFloor] =
    components;

  console.info(`Shared device detected: ${subdomain}`);

  return {
    airport,
    flightType,
    terminal,
    floor,
    lounge,
    deviceFloor,
  };
};
